// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const BidirectionalOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","focusable":"false"},"children":[{"tag":"g","attrs":{"clip-path":"url(#clip0_2421_10258)","fill":"currentColor"},"children":[{"tag":"path","attrs":{"d":"M14.94 7.45l-7.58 7.58 1.89 1.89H4.21v-5.05l1.88 1.9 7.58-7.58-1.89-1.9 5.13-.08-.08 5.13-1.9-1.9z"}},{"tag":"path","attrs":{"d":"M13.84 19.5l2.12-2.13-9.23-9.23-2.12 2.12-.1-5.75 5.75.1-2.12 2.12 9.23 9.23 2.12-2.12v5.65h-5.65z"}}]},{"tag":"defs","attrs":{},"children":[{"tag":"clipPath","attrs":{"id":"clip0_2421_10258"},"children":[{"tag":"path","attrs":{"d":"M0 0h24v24H0z","fill":"currentColor"}}]}]}]},"name":"bidirectional","theme":"outlined"};

const BidirectionalOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={BidirectionalOutlinedSvg} />;
  BidirectionalOutlined.displayName = 'BidirectionalOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(BidirectionalOutlined);
